
export default function (value) {
  return isNaN(value) ? value : Number(value)
}
